export enum TransactioneElecStatus {
  'Tất cả' = 'Tất cả',
  // 'Đang xử lý' = 'Đang xử lý',
  'Thành công' = 'Thành công',
  'Thất bại' = 'Thất bại',
  'Đang chờ hủy' = 'Đang chờ hủy',
  'Đã hủy' = 'Đã hủy',
  'Chờ đối soát' = 'Chờ đối soát',
}

// export const StatusColor = {
//   'Thành công': 'textSuccess',
//   'Đang xử lý': 'textInfo',
//   'Thất bại': 'textDanger',
//   'Đã hủy': 'textDanger',
// };

export enum TransactionTypes {
  'Tất cả' = 'Tất cả',
  'TD' = 'Tiền điện',
}

export enum CompanyExtendQuery {
  'Tất cả' = 'Tất cả',
}

export enum LeaderExtendQuery {
  'Tất cả' = 'Tất cả',
}

export enum TransactionStatusEnum {
  'Thành công' = 'Thành công',
  'Đang xử lý' = 'Đang xử lý',
  'Đang chờ hủy' = 'Đang chờ hủy',
  'Thất bại' = 'Thất bại',
  'Đã hủy' = 'Đã hủy',
  'Chờ đối soát' = 'Chờ đối soát',
}

export const TransactionStatusColor = {
  'Thành công': 'textSuccess',
  'Hoàn thành': 'textSuccess',
  'Đang xử lý': 'textInfo',
  'Đang chờ hủy': 'textWarning',
  'Thất bại': 'textDanger',
  'Đã hủy': 'textDanger',
  'Chờ đối soát': 'textWarning',
};

export const RequestWithdrawStatusColor = {
  'Thành công': 'textSuccess',
  'Đang xử lý': 'textInfo',
  'Từ chối': 'textDanger',
  'Chuyển tiền tự động thất bại': 'textDanger',
  'Đang chuyển tiền tự động': 'textInfo',
};

export enum TransactionStatusAllEnum {
  ALL = 'Tất cả',
}

export enum OrderStatusEnum {
  COMPLETED = 'Hoàn thành',
  IN_PROCESS = 'Đang xử lý',
}

export enum PointTransactionStatus {
  'Tất cả' = 'Tất cả',
  // 'Đang xử lý' = 'Đang xử lý',
  'Thành công' = 'Thành công',
  'Thất bại' = 'Thất bại',
  'Đang chờ hủy' = 'Đang chờ hủy',
  'Đã hủy' = 'Đã hủy',
  'Đang xử lý' = 'Đang xử lý',
  'Chờ đối soát' = 'Chờ đối soát',
}

export enum RequestWithdrawStatus {
  'Tất cả' = 'Tất cả',
  'Đang xử lý' = 'Đang xử lý',
  'Chuyển tiền tự động thất bại' = 'Chuyển tiền tự động thất bại',
  'Thành công' = 'Thành công',
  'Từ chối' = 'Từ chối',
}

export enum PointTransactionTypes {
  'Tất cả' = 'Tất cả',
  // 'Thanh toán hóa đơn-Tiền điện' = 'Thanh toán hóa đơn – Tiền điện',
  'Nạp điểm' = 'Nạp điểm',
  'Chuyển điểm' = 'Chuyển điểm',
  'Chuyển khoản ngân hàng' = 'Chuyển khoản ngân hàng',
  'Nhận điểm' = 'Nhận điểm',
  'Hoàn điểm' = 'Hoàn điểm',
  'Rút điểm' = 'Rút điểm',
  'Điểm giới thiệu' = 'Điểm giới thiệu',
  'Thanh toán' = 'Thanh toán',
  'Nhận thanh toán' = 'Nhận thanh toán',
  // 'Đặt cọc lô đất ZenOne' = 'Đặt cọc lô đất ZenOne',
  // 'Chuyển điểm giới thiệu' = 'Chuyển điểm giới thiệu',
  // 'Nhận điểm giới thiệu' = 'Nhận điểm giới thiệu',
  // 'Thanh toán xăng dầu' = 'Thanh toán xăng dầu',
  // 'Nhận thanh toán xăng dầu' = 'Nhận thanh toán xăng dầu'
}

export enum PointTransactionOilTypes {
  'Tất cả' = 'Tất cả',
  'Thanh toán' = 'Thanh toán',
  'Nhận thanh toán' = 'Nhận thanh toán',
}

export enum RequestTxWithdrawStatus {
  'Tất cả' = 'Tất cả',
  'INIT' = 'Khởi tạo',
  'ERROR' = 'Lỗi',
  'APPROVED' = 'Được phê duyệt',
  'SUCCESS' = 'Thành công',
  'TIMEOUT' = 'Thời gian chờ',
  'FAILED' = 'Thất bại',
  'CANCEL' = 'Đã hủy',
  'REJECT' = 'Đã từ chối',
}

export const PointTransactionTypesColor = {
  'Tiền điện': 'textDanger',
  'Nạp điểm': 'textInfo',
  'Chuyển điểm': 'textDanger',
  'Nhận điểm': 'textInfo',
  'Hoàn điểm': 'textInfo',
  'Rút điểm': 'textDanger',
  'Chuyển điểm giới thiệu': 'textDanger',
  'Nhận điểm giới thiệu': 'textInfo',
  'Đặt cọc lô đất ZenOne': 'textInfo',
};

export enum OrderTypes {
  'Tiền điện' = 'TD',
}

export enum OrderStatusFilterEnum {
  'Tất cả' = 'Tất cả',
  'Hoàn thành' = 'Hoàn thành',
  'Đang xử lý' = 'Đang xử lý',
}

export enum RoleTypes {
  'Tất cả' = 'Tất cả',
  'Đại lý' = 'Agency',
  'Trưởng nhóm' = 'Leader',
  // 'Nhân viên đối soát' = 'SpVisor',
  'Merchant' = 'OilMc',
}

export enum RoleTypesAll {
  'Nhân viên' = 'Staff',
  'Merchant' = 'Mc',
  'Admin' = 'Admin',
}

export const NewRoleTypes = {
  'Tất cả': RoleTypes['Tất cả'],
  ...RoleTypesAll,
} as const;

export enum StatusTypes {
  'Tất cả' = 'Tất cả',
  'Hoạt động' = 'true',
  'Không hoạt động' = 'false',
}

export enum LocalStorageKey {
  ADMIN_ACTIONS = 'adminActions',
  SESSION_MARKER = 'sessionMarker',
}
